import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Footer = () => {
  return (
    <footer className="bg-light py-4 mt-5">
      <Container>
        <Row>
          <Col md={6}>
            <h5>About Us</h5>
            <p>
              We are passionate about travel and helping you explore the world.
            </p>
          </Col>
          <Col md={3}>
            <h5>Links</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/" className="">
                  Home
                </a>
              </li>
              <li>
                <a href="../contact-us" className="">
                  Contact
                </a>
              </li>
              <li>
                <a href="/privacy" className="">
                  Privacy
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3}>
            <h5>Follow Us</h5>
            <ul className="list-unstyled">
              <li>
                <a href="#" className="">
                  Facebook
                </a>
              </li>
              <li>
                <a href="#" className="">
                  Twitter
                </a>
              </li>
              <li>
                <a href="#" className="">
                  Instagram
                </a>
              </li>
            </ul>
          </Col>
        </Row>
        <hr className="border-light" />
        <p className="text-center mb-0">
          &copy; {new Date().getFullYear()} Dhanam Information Systems. All rights reserved.
        </p>
      </Container>
    </footer>
  );
};

export default Footer;
